import { useQuery } from '@apollo/client';
import { READ_PARKING_SESSION } from 'graphql/queries/readParkingSession';
import { useParkingStore } from 'stores/parkingStore';
import {
  Query,
  QueryReadParkingSessionArgs,
  ParkingPaymentState,
} from 'types/generatedSchemaTypes';
import { AWAITING_EXTERNAL_PAYMENT_STATES } from 'utils/paymentUtils';

const useSessionPaymentState = () => {
  const sessionId = useParkingStore((state) => state.currentParkingSession);
  let paymentState: ParkingPaymentState | undefined;

  const { data, loading, startPolling, stopPolling } = useQuery<
    Query,
    QueryReadParkingSessionArgs
  >(READ_PARKING_SESSION, {
    variables: { sessionId: sessionId || '' },
    skip: !sessionId || sessionId.length === 0,
    fetchPolicy: 'cache-and-network',
  });

  if (data) {
    paymentState = data.readParkingSession?.paymentState as ParkingPaymentState;
  }
  const awaitingPayment =
    !!paymentState && AWAITING_EXTERNAL_PAYMENT_STATES.includes(paymentState);
  if (data) {
    awaitingPayment ? startPolling(1000) : stopPolling();
  }

  const pending = loading || awaitingPayment;
  return {
    pending,
    paymentState,
  };
};

export default useSessionPaymentState;
